export const environment = {
  production: true,
  envSuffix: ' ┃ DEV',
  redirectUri: 'https://clockload.dev.sla-handling.devtest.gf.aws.scania.com/',
  urlApi: 'https://clockload-api.dev.sla-handling.devtest.gf.aws.scania.com/',
  auth: {
    clientId: 'acd69533-1b29-465c-acaf-2edb9e630f3f',
    authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    apiScope: 'api://acd69533-1b29-465c-acaf-2edb9e630f3f/User.Read',
    graphScopes: ['User.Read'],
  },
};
